import { useWorkflow } from '../workflows/queries/useWorkflow';
import { WorkflowType } from '../workflows/types';
import { useSource } from '../sources/queries/useSource';
import { RepoConfigResponse } from '../types';

export function useWorkflowGitConfig(
  workflowId: number,
  stackId: number,
  artifactType: WorkflowType
) {
  const workflowQuery = useWorkflow(workflowId);

  // every artifact currently has exactly one file; each file has its own
  // sourceId/ref, so picking [0] would be wrong if that ever changes
  const file = workflowQuery.data?.artifacts.find(
    (artifact) => artifact.id === stackId && artifact.type === artifactType
  )?.files[0];

  const sourceQuery = useSource(file?.sourceId);

  const gitConfig: RepoConfigResponse | undefined =
    file && sourceQuery.data
      ? {
          URL: sourceQuery.data.url,
          ReferenceName: file.ref ?? '',
          ConfigFilePath: file.path ?? '',
          ConfigHash: file.hash ?? '',
          TLSSkipVerify: sourceQuery.data.connection.tlsSkipVerify ?? false,
          Authentication: sourceQuery.data.connection.authentication
            ? { Username: sourceQuery.data.connection.authentication.username }
            : undefined,
        }
      : undefined;

  return {
    gitConfig,
    sourceId: file?.sourceId,
    isLoading: workflowQuery.isLoading || sourceQuery.isInitialLoading,
    isError: workflowQuery.isError || sourceQuery.isError,
  };
}
